import { CURRENCY_NAME, VAT_RATE } from "../services/constants";

function formatPrice(price) {
    return price.toLocaleString("fr-FR", {
        style: "currency",
        currency: CURRENCY_NAME,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

function round(price, decimals = 2) {
    const factorOfTen = 10 ** decimals;
    return Math.round((price + Number.EPSILON * factorOfTen) * factorOfTen) / factorOfTen;
}

function getVATAmount(price) {
    return (price * VAT_RATE) / 100;
}

function marginCalculation(costPrice, marge) {
    // OLD FORMULA : (costPrice * marge) / 100 + costPrice;
    return costPrice / (1 - marge / 100);
}

function buyPriceOperation(totalPriceArticles, totalPriceCustomizations) {
    return totalPriceArticles + totalPriceCustomizations;
}

function costPriceOperation(buyPrice, multiplicator) {
    return buyPrice * multiplicator;
}

function removeMarginFromSellPrice(sellPrice, marge) {
    // OlLD FORMULA : return ((100 - marge) / 100) * costPrice;
    return sellPrice * (1 - marge / 100);
}

export {
    formatPrice,
    getVATAmount,
    round,
    buyPriceOperation,
    removeMarginFromSellPrice,
    costPriceOperation,
    marginCalculation,
};
